module.exports = __webpack_public_path__ + "img/drivers-do.a5276f47.png";